<template>
  <div class="sqhdCard box">
    <div style="margin-right:60px">
      <div style="font-size: 34px;height: 35px;line-height: 35px">{{ activityInfo.title }}</div>
      <div class="huodong">
        <div>活动时间：{{activityInfo.starttime}}&nbsp;至 {{activityInfo.endtime}}</div>
        <div>活动地点：{{ activityInfo.address }}</div>
        <div class="zhuban">主办方：{{activityInfo.sponsorName }}</div>
      </div>
      <div>
      <x-scroll :contentArr="bmarr" :height="130" :lineNum="5" :width="235" :time="5000" :chixuTime="5">
          <div class="box" style="height: 130px;width:235px;align-items: center" slot="scroll" slot-scope="props">
            <div style="height:70px;width: 70px;margin-right: 10px">
              <img :src="props.todo.headPicUrl" style="height: 70px;width: 70px;border-radius: 50%">
            </div>
            <div class="box_v" style="justify-content: center">
              <div style="font-size: 26px;color:#444">{{props.todo.userName}}</div>
              <div style="font-size: 20px;color:#9d9392">{{props.todo.time}}</div>
            </div>
          </div>
      </x-scroll>
      </div>
    </div>
    <div style="width: 460px;height:310px;position: relative">
      <div style="width: 180px;height: 180px;position: absolute;top:94px;left:221px">
        <img :src="activityInfo.qrcode" style="height: 100%;width: 100%;border-radius: 5px" />
      </div>
      <img src="../../../assets/staticsPic/saoma.png" style="height: 100%;width: 100%" />
    </div>
  </div>
</template>

<script>
  import xScroll from '../../../components/xScroll'
  export default {
    props:{
      activityInfo:{
        type:Object,
        default:{}
      },
      bmarr:{
        type:Array,
        default: []
      }
    },
    data () {
      return {
      }
    },
    components: {
      xScroll
    },

  }
</script>

<style scoped>
 .sqhdCard{
   height: 350px;
   width: 1800px;
   border: 2px solid #fff;
   border-radius: 10px;
   background-color: rgba(255,255,255,0.5);
   margin: 0 auto;
   padding:30px
 }
  .huodong{
    width: 1225px;
    font-size: 22px;
    color:#666;
    padding:40px 0;
    line-height: 1.5;
    border-bottom: 1px solid #bcbdb7;
    position: relative;
  }
  .zhuban{
    color: #ff5d33;
    position: absolute;
    bottom:30px;
    right:0;
  }

</style>
